import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";

const styles = {
  activeLink: {
    fontWeight: styleConstants.fontWeights.bold,
    color: styleConstants.colors.themeBlue
  },
  link: {
    cursor: "pointer",
    color: styleConstants.colors.themeBlue,
    textDecoration: "none",
    borderBottom: `1px ${styleConstants.colors.themeBlue} solid`,
    transition: "all 0.25s ease",
    "&:hover": {
      borderColor: styleConstants.colors.themeBlueMedium,
      color: styleConstants.colors.themeBlueMedium
    }
  }
};

const AnnexNavItem = props => (
  <div className={props.classes.container}>
    <a href={`#${props.linkTo}`} className={props.classes.link}>
      <>{props.children}</>
    </a>
  </div>
);

AnnexNavItem.propTypes = {
  linkTo: PropTypes.string.isRequired
};

export default withStyles(styles)(AnnexNavItem);
